import { render, staticRenderFns } from "./queryTypeModal.vue?vue&type=template&id=24e9f4a8&scoped=true&"
import script from "./queryTypeModal.vue?vue&type=script&lang=js&"
export * from "./queryTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./queryTypeModal.vue?vue&type=style&index=0&id=24e9f4a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9f4a8",
  null
  
)

export default component.exports